import type { ICellRendererParams } from 'ag-grid-community';
import { hideOnImgError, imageUrl } from '@utils/imageUrl';
import type { Variety } from '../../schema';

export function VarietyImageCell(p: ICellRendererParams<Variety>) {
  if (!p.data) return null;
  const url = imageUrl(p.data.thumbnailStorageKey ?? p.data.imageStorageKey);
  if (!url) {
    return <span className="text-border-strong">—</span>;
  }
  return (
    <div className="flex h-full items-center">
      <img
        src={url}
        alt={p.data.name}
        className="h-9 w-9 rounded-md object-cover ring-1 ring-border"
        onError={hideOnImgError}
      />
    </div>
  );
}
